import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Importing components
import { Controls } from '../../components/player/controls';
import { PlayerElement } from './player-element';
import { PlayerSkeleton } from './skeletons';
import { PlayerNotFound } from './player-not-found';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing store
import { usePlayerStore } from '../../store/player.store';
// Importing types
import { PlayerControls, PlayerType } from '../../types/player';
// Importing 3rd party components
import Box from '@mui/material/Box';
import { Waveform } from './waveform';
import { Captions } from './captions';
// ----------------------------------------------------------------------
export const AudioPlayer = () => {
    // Adding player store
    const { available, error, togglePlaying } = usePlayerStore(useShallow((state) => ({
        available: state.available,
        error: state.error,
        togglePlaying: state.togglePlaying,
    })));
    return (_jsxs(Box, { sx: { position: 'relative' }, children: [_jsxs(Box, Object.assign({}, (available && !error && { onClick: () => togglePlaying() }), { sx: {
                    cursor: 'pointer',
                    pt: 2,
                }, children: [!available && _jsx(PlayerSkeleton, { type: PlayerType.audio }), error && _jsx(PlayerNotFound, { type: PlayerType.audio }), available && !error && _jsx(Waveform, {}), _jsx(PlayerElement, {})] })), _jsx(Box, { sx: { position: 'absolute' }, children: _jsx(Captions, { type: PlayerType.audio }) }), available && !error && (_jsx(Controls, { controls: [
                    PlayerControls.captions,
                    PlayerControls.chapters,
                    PlayerControls.duration,
                    PlayerControls.play,
                    PlayerControls.progressBar,
                    PlayerControls.volume,
                ] }))] }));
};
